import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";
import { FiPhone, FiMail, FiMapPin, FiClock } from 'react-icons/fi';

function ContactUsPage() {
    const navigate = useNavigate();
    // Google Maps embed for Kipps Super Market (Rajendra Nagar, Bareilly)
    const googleMapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3510.1701340888976!2d79.42083657428135!3d28.38392887580138!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39a0071dc50451f7%3A0x9a5dca1f3670a828!2sKipps%20-%20Super%20Market!5e0!3m2!1sen!2sin!4v1755429445873!5m2!1sen!2sin";

    return (
        <Fragment>
            <div className='container-fluid m-t25'>
                <div className='row'>
                    <div className='col-12 cat-strip border shadow-sm'>
                        <div>
                            <button onClick={() => navigate(-1)}><IoMdArrowRoundBack /></button>
                            <label>CONTACT US</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className='contact-hero text-center'>
                <div className='inner'>
                    <h1 className='contact-title'>We'd Love To Hear From You</h1>
                    <p className='lead mb-0'>Questions, feedback or custom order? Reach out and our team will assist you.</p>
                </div>
            </div>
            <div className='contact-section container-lg px-3 px-sm-4 py-4 py-sm-5'>
                <div className='row g-4'>
                    <div className='col-md-6 col-lg-4'>
                        <div className='contact-card h-100 horizontal'>
                            <div className='icon-col'><div className='icon-wrap'><FiMapPin /></div></div>
                            <div className='content-col'>
                                <h2>Address</h2>
                                <p className='mb-2 fw-semibold'>Kipps Sweets – Rajendra Nagar</p>
                                <p className='mb-0 small text-muted'>Kipps Super Market, Rajendra Nagar<br/>Bareilly, Uttar Pradesh – 243122</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6 col-lg-4'>
                        <div className='contact-card h-100 horizontal'>
                            <div className='icon-col'><div className='icon-wrap'><FiPhone /></div></div>
                            <div className='content-col'>
                                <h2>Call</h2>
                                <p className='mb-1'><a href='tel:+919837012345' className='contact-link'>+91 98370 12345</a></p>
                                <p className='mb-0 small text-muted'>Mon – Sun, 9:00 AM – 9:30 PM</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6 col-lg-4'>
                        <div className='contact-card h-100 horizontal'>
                            <div className='icon-col'><div className='icon-wrap'><FiMail /></div></div>
                            <div className='content-col'>
                                <h2>Email</h2>
                                <p className='mb-1'><a href='mailto:support@kippssweets.in' className='contact-link'>support@kippssweets.in</a></p>
                                <p className='mb-0 small text-muted'>We reply within 24 hours.</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6 col-lg-4'>
                        <div className='contact-card h-100 horizontal'>
                            <div className='icon-col'><div className='icon-wrap'><FiClock /></div></div>
                            <div className='content-col'>
                                <h2>Working Hours</h2>
                                <ul className='hours-list small mb-0'>
                                    <li><span>Mon – Sun</span><span>9:00 AM – 9:30 PM</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='contact-map container-lg px-0 mb-5'>
                <div className='ratio ratio-21x9 contact-map-embed position-relative'>
                    <iframe
                        title='Kipps Super Market Location Map'
                        src={googleMapSrc}
                        style={{ border: 0, width: '100%', height: '100%' }}
                        loading='lazy'
                        allowFullScreen
                        referrerPolicy='no-referrer-when-downgrade'
                        aria-label='Map showing location of Kipps Super Market in Rajendra Nagar Bareilly'
                    />
                    <a
                        href='https://maps.google.com/?q=Kipps+Super+Market+Bareilly'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='visually-hidden'
                        aria-hidden='false'
                    >Open in Google Maps</a>
                </div>
            </div>
        </Fragment>
    );
}

export default ContactUsPage;
